
import Scroller from 'vux/src/components/scroller/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Picker from 'vux/src/components/picker/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import {eventBus} from '../../../eventbus'
export default {
components: { Scroller, Checker, CheckerItem, Picker, GroupTitle, XButton, PopupRadio, XDialog, Flexbox, FlexboxItem },
data () {
return {
type: this.$route.params.type,
caseId: this.$route.params.caseid,
reportId: this.$route.params.reportid,
diagCropMin: '',
diagCropMax: '',
cropList: [],
cropAddrArray: [],
diagnoseDescShow: true,
diagnoseDescTitle: '',
microbeProjectShow: true,
microbeProjectTitle: '',
diagnoseResultShow: true,
diagnoseResultTitle: '',
dnaResultShow: '',
dnaResultTitle: '',
cellResult: '',
cellResultShow: true,
cellResultShowSd: true,
cellResultTitle: '',
remarkShow: true,
remarkTitle: '',
finalResult: '',
oneKnowledge: [],
twoKnowledge: [],
threeKnowledge: [],
fourKnowledge: [],

threeDefaultRadio: [],
twoDefaultRadio: [],
twoDefaultRadiosd: [],
threeDefaultRee: [],
twoDefaultRee: [],
twoDefaultReesd: [],
oneValue: [''],
twoValue: [''],
twoValuesd: [''],
threeValue: [''],
fourValue: [''],
oneDefault: [''],
fourDefault: [],
changeName: '',
fourtext: '',
fourOldValue: '',

oneTree: [],
twoTree: [],
threeTree: [],
fourTree: [],
oneValueTwo: [''],
twoValueTwo: [''],
threeValueTwo: [''],
fourValueTwo: [''],
oneDefList: [],
fourDefList: [],
valSign: '',
oneArray: [],
fourArray: [],
oneShow: true,
twoShow: true,
twoShowsd: true,
threeShow: true,
fourShow: true,
iconfont: ['iconfont', 'cell-report-edit-icon-padding'],
iconDown: 'icon-circle-down',
iconUp: ['icon-circle-up', 'cell-report-edit-blue'],
innerCtn: 'cell-report-edit-innerCtn',
innerCtnBig: 'cell-report-edit-innerCtn-big',
diagnoseDesc: '',
microbeProject: '',
diagnoseResult: '',
diagnoseResultsd: '',
remark: '',
caseType: '',
fz: '',
canFinish: '',
canNextDoctor: '',
canNextHosp: '',
czCanFinish: '',
fzDoc: [''],
fzDocNames: '',
addFzShow: false,
tipShow: false,
tip: '',
cellResult1: '',
cellResult2: '',
cellResult3: '',
cellResult4: '',
cellResult5: '',
caseSubject: ''
}
},
computed: {
subjectResultText: function () {
return this.diagnoseDesc + '\r\n' + this.microbeProject
}
},
beforeMount () {
this.$vue = this
this.getPageData()
},
methods: {
async assKnowledge (type, selectVal, val, caseId) {
if (selectVal.indexOf(val) > 0) {
let params = new URLSearchParams()
params.append('CASE_ID', caseId)
params.append('val', val)
params.append('CASE_TYPE', type)
let suc = await this.$http.post(this.$vue.getData('GET_ASS_KNOWLEDGE'), params)
if (suc.data.result === '1') {
if (type === '1') {
if (suc.data.data.twoAssKnowledge.length > 0) {
this.twoValue = suc.data.data.twoAssKnowledge
}
if (suc.data.data.threeAssKnowledge.length > 0) {
this.threeValue = suc.data.data.threeAssKnowledge
}
if (suc.data.data.fourAssKnowledge.length > 0) {
this.fourValue = suc.data.data.fourAssKnowledge
}
} else if (type === '2') {
if (suc.data.data.oneAssKnowledge.length > 0) {
this.oneValue = suc.data.data.oneAssKnowledge
}
if (suc.data.data.threeAssKnowledge.length > 0) {
this.threeValue = suc.data.data.threeAssKnowledge
}
if (suc.data.data.fourAssKnowledge.length > 0) {
this.fourValue = suc.data.data.fourAssKnowledge
}
} else if (type === '3') {
if (suc.data.data.oneAssKnowledge.length > 0) {
this.oneValue = suc.data.data.oneAssKnowledge
}
if (suc.data.data.twoAssKnowledge.length > 0) {
this.twoValue = suc.data.data.twoAssKnowledge
}
if (suc.data.data.fourAssKnowledge.length > 0) {
this.fourValue = suc.data.data.fourAssKnowledge
}
} else if (type === '4') {
if (suc.data.data.oneAssKnowledge.length > 0) {
this.oneValue = suc.data.data.oneAssKnowledge
}
if (suc.data.data.twoAssKnowledge.length > 0) {
this.twoValue = suc.data.data.twoAssKnowledge
}
if (suc.data.data.threeAssKnowledge.length > 0) {
this.threeValue = suc.data.data.threeAssKnowledge
}
} else if (type === '5') {

if (suc.data.data.oneAssKnowledge.length > 0) {
this.oneValue = suc.data.data.oneAssKnowledge
}
if (suc.data.data.twoAssKnowledge.length > 0) {
this.twoValuesd = suc.data.data.twoAssKnowledge
}
if (suc.data.data.threeAssKnowledge.length > 0) {
this.threeValue = suc.data.data.threeAssKnowledge
}
}
}
}
},
async getPageData () {
eventBus.$emit('showLoading', true, '加载中')
let params = new URLSearchParams()

if (this.type === '0') {
params.append('CASE_ID', this.caseId)
let suc = await this.$http.post(this.$vue.getData('GO_DIAG_REPORT'), params)
if (suc.data.result === '1') {
if (suc.data.data.caseType === '1') {
this.diagCropMin = suc.data.data.pdModelConfig.DIAGNOSE_CROP_MIN
this.diagCropMax = suc.data.data.pdModelConfig.DIAGNOSE_CROP_MAX
this.diagnoseDescShow = suc.data.data.pdModelConfig.DIAGNOSE_DESC_SHOW === '1'
this.diagnoseDescTitle = suc.data.data.pdModelConfig.DIAGNOSE_DESC_TITLE
this.microbeProjectShow = suc.data.data.pdModelConfig.MICROBE_DESC_SHOW === '1'
this.microbeProjectTitle = suc.data.data.pdModelConfig.MICROBE_DESC_TITLE
this.diagnoseResultShow = suc.data.data.pdModelConfig.DIAGNOSE_RESULT_SHOW === '1'
this.diagnoseResultTitle = suc.data.data.pdModelConfig.DIAGNOSE_RESULT_TITLE
this.dnaResultShow = suc.data.data.pdModelConfig.DNA_RESULT_SHOW === '1'
this.dnaResultTitle = suc.data.data.pdModelConfig.DNA_RESULT_TITLE
this.cellResultShow = suc.data.data.pdModelConfig.CELL_RESULT_SHOW === '1'
this.cellResultShowSd = suc.data.data.pdModelConfig.MODEL_DIAGNOSIS_NUM === '2'
this.cellResultTitle = suc.data.data.pdModelConfig.CELL_RESULT_TITLE
this.remarkShow = suc.data.data.pdModelConfig.REMARK_SHOW === '1'
this.remarkTitle = suc.data.data.pdModelConfig.REMARK_TITLE
this.cropList = suc.data.data.cropList
this.cropAddrArray = suc.data.data.cropAddrArray
this.cellResult = suc.data.data.cellResult
this.cellResult1 = this.cellResult.substring(this.cellResult.indexOf(':') + 2, this.cellResult.indexOf('细胞：') + 3)
this.cellResult2 = this.cellResult.substring(this.cellResult.indexOf('细胞：') + 3, this.cellResult.indexOf('个，'))
this.cellResult3 = this.cellResult.substring(this.cellResult.indexOf('个，'), this.cellResult.lastIndexOf('细胞：') + 3)
this.cellResult4 = this.cellResult.substring(this.cellResult.lastIndexOf('细胞：') + 3, this.cellResult.lastIndexOf('个。'))
this.cellResult5 = this.cellResult.substring(this.cellResult.lastIndexOf('个。'), this.cellResult.length)
this.caseType = suc.data.data.caseType
this.twoKnowledge = suc.data.data.twoKnowledge
this.threeKnowledge = suc.data.data.threeKnowledge
this.caseSubject = suc.data.data.caseSubject

this.twoDefaultRadio = suc.data.data.twoDefaultRadio.length === 0 ? [''] : suc.data.data.twoDefaultRadio
this.twoDefaultRee = suc.data.data.twoDefaultRee.length === 0 ? [''] : suc.data.data.twoDefaultRee
this.twoDefaultRadiosd = suc.data.data.twoDefaultRee.length === 0 ? [''] : suc.data.data.twoDefaultRee
this.twoDefaultReesd = suc.data.data.twoDefaultRee.length === 0 ? [''] : suc.data.data.twoDefaultRee
this.threeDefaultRadio = suc.data.data.threeDefaultRadio.length === 0 ? [''] : suc.data.data.threeDefaultRadio
this.threeDefaultRee = suc.data.data.threeDefaultRee.length === 0 ? [''] : suc.data.data.threeDefaultRee
this.twoValue = suc.data.data.twoDefaultKnowledge.length === 0 ? [''] : suc.data.data.twoDefaultKnowledge
this.twoValuesd = suc.data.data.twoDefaultKnowledge.length === 0 ? [''] : suc.data.data.twoDefaultKnowledge
this.threeValue = suc.data.data.threeDefaultKnowledge.length === 0 ? [''] : suc.data.data.threeDefaultKnowledge
this.fz = suc.data.data.button.fz
this.canFinish = suc.data.data.button.canFinish
this.canNextDoctor = suc.data.data.button.canNextDoctor
this.canNextHosp = suc.data.data.button.canNextHosp
this.czCanFinish = suc.data.data.button.czCanFinish
this.fzDocNames = suc.data.data.fzDocNames

this.oneTree = suc.data.data.oneTree
this.fourTree = suc.data.data.fourTree
this.threeTree = suc.data.data.threeTree
this.twoTree = suc.data.data.twoTree
this.oneDefault = suc.data.data.oneDefault.length === 0 ? [''] : suc.data.data.oneDefault

this.fourDefault = suc.data.data.fourDefault.length === 0 ? [''] : suc.data.data.fourDefault

this.diagnoseDesc = suc.data.data.oneDefault.length === 0 ? [''] : suc.data.data.oneDefault.toString().replace(/,/g, '\r\n')
this.microbeProject = suc.data.data.fourDefault.length === 0 ? [''] : suc.data.data.fourDefault.toString().replace(/,/g, '\r\n')
this.diagnoseResult = suc.data.data.twoDefaultRadio.length === 0 && suc.data.data.twoDefaultRee.length === 0 ? [''] : suc.data.data.twoDefaultRadio + suc.data.data.twoDefaultRee
this.remark = suc.data.data.threeDefaultRadio.length === 0 && suc.data.data.threeDefaultRee.length === 0 ? [''] : suc.data.data.threeDefaultRadio + suc.data.data.threeDefaultRee
}
}
}

if (this.type === '1') {
params.append('ID', this.reportId)
let succ = await this.$http.post(this.$vue.getData('COPY_REPORT'), params)
if (succ.data.result === '1') {
if (succ.data.data.pdCase.CASE_TYPE === 1) {
this.diagCropMin = succ.data.data.pdModelConfig.DIAGNOSE_CROP_MIN
this.diagCropMax = succ.data.data.pdModelConfig.DIAGNOSE_CROP_MAX
this.diagnoseDescShow = succ.data.data.pdModelConfig.DIAGNOSE_DESC_SHOW === '1'
this.diagnoseDescTitle = succ.data.data.pdModelConfig.DIAGNOSE_DESC_TITLE
this.microbeProjectShow = succ.data.data.pdModelConfig.MICROBE_DESC_SHOW === '1'
this.microbeProjectTitle = succ.data.data.pdModelConfig.MICROBE_DESC_TITLE
this.diagnoseResultShow = succ.data.data.pdModelConfig.DIAGNOSE_RESULT_SHOW === '1'
this.diagnoseResultTitle = succ.data.data.pdModelConfig.DIAGNOSE_RESULT_TITLE
this.dnaResultShow = succ.data.data.pdModelConfig.DNA_RESULT_SHOW === '1'
this.dnaResultTitle = succ.data.data.pdModelConfig.DNA_RESULT_TITLE
this.cellResultShow = succ.data.data.pdModelConfig.CELL_RESULT_SHOW === '1'
this.cellResultShowSd = succ.data.data.pdModelConfig.MODEL_DIAGNOSIS_NUM === '2'
this.cellResultTitle = succ.data.data.pdModelConfig.CELL_RESULT_TITLE
this.remarkShow = succ.data.data.pdModelConfig.REMARK_SHOW === '1'
this.remarkTitle = succ.data.data.pdModelConfig.REMARK_TITLE
this.cropList = succ.data.data.cropList
this.cropAddrArray = succ.data.data.cropAddrArray
this.cellResult = succ.data.data.pdReport.DNA_RESULT
this.cellResult1 = this.cellResult.substring(this.cellResult.indexOf(':') + 2, this.cellResult.indexOf('细胞：') + 3)
this.cellResult2 = this.cellResult.substring(this.cellResult.indexOf('细胞：') + 3, this.cellResult.indexOf('个，'))
this.cellResult3 = this.cellResult.substring(this.cellResult.indexOf('个，'), this.cellResult.lastIndexOf('细胞：') + 3)
this.cellResult4 = this.cellResult.substring(this.cellResult.lastIndexOf('细胞：') + 3, this.cellResult.lastIndexOf('个。'))
this.cellResult5 = this.cellResult.substring(this.cellResult.lastIndexOf('个。'), this.cellResult.length)
this.diagnoseDesc = succ.data.data.pdReport.DIAG_DESC
this.microbeProject = succ.data.data.pdReport.MICRO_PRO
this.fourValue = succ.data.data.pdReport.MICRO_PRO.length === 0 ? [''] : succ.data.data.pdReport.MICRO_PRO
this.diagnoseResult = succ.data.data.pdReport.DIAGNOSE_RESULT
this.twoValuesd = succ.data.data.pdReport.DIAGNOSE_RESULT.length === 0 ? [''] : succ.data.data.pdReport.DIAGNOSE_RESULT
this.remark = succ.data.data.pdReport.RECOMMENDATION
this.threeValue = succ.data.data.pdReport.RECOMMENDATION.length === 0 ? [''] : succ.data.data.pdReport.RECOMMENDATION
this.caseType = succ.data.data.pdCase.CASE_TYPE
this.twoKnowledge = succ.data.data.twoKnowledge
this.threeKnowledge = succ.data.data.threeKnowledge
this.caseSubject = succ.data.data.caseSubject

this.oneTree = succ.data.data.oneTree
this.twoTree = succ.data.data.twoTree
this.threeTree = succ.data.data.threeTree
this.fourTree = succ.data.data.fourTree
}
}
}
eventBus.$emit('showLoading', false)
},
oneSelect (val) {
var a = ''
for (var i = 0; i < this.oneDefault.length; i++) {
if (this.oneDefault[i] === val) {
a = 'valSigin'
}
}
if (a !== '') {
return true
} else {
return false
}
},
fourSelect (val) {
var a = ''
for (var i = 0; i < this.fourDefault.length; i++) {
if (this.fourDefault[i] === val) {
a = 'valSigin'
}
}
if (a !== '') {
return true
} else {
return false
}
},

changeOneValue (oneVal, twoVal) {
this.valSign = ''
this.oneValue = twoVal
if (this.oneDefault.length > 0) {
this.oneDefList = this.oneDefault.toString().split(',')
for (var i = 0; i < this.oneDefList.length; i++) {
if (this.oneDefList[i].split('：')[0] === oneVal) {
if (this.oneDefList[i].indexOf(oneVal + '：' + twoVal) !== 0) {
this.oneDefList[i] = oneVal + '：' + twoVal
}
this.valSign = 'sign'
}
}
if (this.valSign !== 'sign') {
this.valSign = ''
this.oneDefList = this.oneDefList + ',' + oneVal + '：' + twoVal
}
}
this.oneDefault = this.oneDefList
},

oneReelected (oneVal, twoVal) {
this.valSign = ''
this.n = 0
this.val = oneVal + '：' + twoVal
this.oneDefList = this.oneDefault.toString().split(',')
for (var j = 0; j < this.oneDefList.length; j++) {
if (this.oneDefList[j].indexOf(oneVal + '：') === 0) {
this.n++
}
}
for (var i = 0; i < this.oneDefList.length; i++) {
if (this.n >= 2) {
if (this.oneDefList[i].indexOf(this.val) === 0) {
this.oneDefList[i] = ''
this.valSign = 'sign'
}
} else {
if (this.oneDefList[i].indexOf(oneVal + '：') === 0) {
if (this.oneDefList[i].toString().split('：')[1] === '') {
this.oneDefList[i] = this.val
this.valSign = 'sign'
} else if (this.oneDefList[i].indexOf(this.val) === 0) {
this.oneDefList[i] = oneVal + '：'
this.valSign = 'sign'
}
}
}
}
if (this.valSign !== 'sign') {
this.valSign = ''
this.oneDefList = this.oneDefList + ',' + oneVal + '：' + twoVal
}
this.oneDefault = this.oneDefList
},

fourReelected (oneVal, twoVal) {
this.valSign = ''
this.n = 0
this.val = oneVal + '：' + twoVal
this.fourDefList = this.fourDefault.toString().split(',')
for (var j = 0; j < this.fourDefList.length; j++) {
if (this.fourDefList[j].indexOf(oneVal + '：') === 0) {
this.n++
}
}
for (var i = 0; i < this.fourDefList.length; i++) {
if (this.n >= 2) {
if (this.fourDefList[i].indexOf(this.val) === 0) {
this.fourDefList[i] = ''
this.valSign = 'sign'
}
} else {
if (this.fourDefList[i].indexOf(oneVal + '：') === 0) {
if (this.fourDefList[i].toString().split('：')[1] === '') {
this.fourDefList[i] = this.val
this.valSign = 'sign'
} else if (this.fourDefList[i].indexOf(this.val) === 0) {
this.fourDefList[i] = oneVal + '：'
this.valSign = 'sign'
}
}
}
}
if (this.valSign !== 'sign') {
this.valSign = ''
this.fourDefList = this.fourDefList + ',' + oneVal + '：' + twoVal
}
this.fourDefault = this.fourDefList
},

fourOneValue (oneVal, twoVal) {
this.valSign = ''
this.oneValue = twoVal
if (this.fourDefault.length > 0) {
this.fourDefList = this.fourDefault.toString().split(',')
for (var i = 0; i < this.fourDefList.length; i++) {
if (this.fourDefList[i].split('：')[0] === oneVal) {
if (this.fourDefList[i].indexOf(oneVal + '：' + twoVal) !== 0) {
this.fourDefList[i] = oneVal + '：' + twoVal
}
this.valSign = 'sign'
}
}
if (this.valSign !== 'sign') {
this.valSign = ''
this.fourDefList = this.fourDefList + ',' + oneVal + '：' + twoVal
}
}
this.fourDefault = this.fourDefList
},
oneChange () {
this.onetext = ''
this.oneArray = this.oneDefList.toString().split(',')
for (var i = 0; i < this.oneArray.length; i++) {
if (this.oneArray[i] !== '') {
if (this.onetext === '') {
this.onetext = this.oneArray[i]
} else {
this.onetext = this.onetext + ',' + this.oneArray[i]
}
}
}
this.oneDefault = this.onetext.toString().split(',')
this.diagnoseDesc = this.onetext.toString().replace(/,/g, '\r\n')

},
twoChange (type) {
if (type === 1) {
this.diagnoseResult = this.twoDefaultRee.toString().replace(/,/g, '') + this.twoDefaultRadio.toString().replace(/,/g, '')
} else {
this.diagnoseResultsd = this.twoDefaultReesd.toString().replace(/,/g, '') + this.twoDefaultRadiosd.toString().replace(/,/g, '')
}

},
threeChange () {
this.remark = this.threeDefaultRee.toString().replace(/,/g, '') + this.threeDefaultRadio.toString().replace(/,/g, '')
},
fourChange () {
this.onetext = ''
this.fourArray = this.fourDefault.toString().split(',')
for (var i = 0; i < this.fourArray.length; i++) {
if (this.fourArray[i] !== '') {
if (this.onetext === '') {
this.onetext = this.fourArray[i]
} else {
this.onetext = this.onetext + ',' + this.fourArray[i]
}
}
}
this.fourDefault = this.onetext.toString().split(',')
this.microbeProject = this.onetext.toString().replace(/,/g, '\r\n')

},
addFzDoc () {
this.addFzShow = true
},
async finishDiagnose (method) {
let subjectResultText = this.subjectResultText
if (subjectResultText === '') {
this.tip = '请添加诊断描述和微生物项目词条！'
this.addFzShow = false
this.tipShow = true
return false
}
let diagnoseDesc = this.diagnoseDesc
if (this.diagnoseDescShow && diagnoseDesc === '') {
this.tip = '请添加诊断描述词条！'
this.addFzShow = false
this.tipShow = true
return false
}
if (this.caseSubject === 1) {
let microbeProject = this.microbeProject
if (this.microbeProjectShow && microbeProject === '') {
this.tip = '请添加微生物项目词条！'
this.addFzShow = false
this.tipShow = true
return false
}
}

let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
params.append('cropAddrArray', this.cropAddrArray)
params.append('diagnoseDesc', this.diagnoseDesc)
params.append('microbeProject', this.microbeProject)

if (this.cellResultShowSd) {
this.diagnoseResult = this.diagnoseResult + '##' + this.diagnoseResultsd
}
params.append('diagnoseResult', this.diagnoseResult)
params.append('remark', this.remark)
let cellRes = this.cellResult
let re = /^[0-9]+$/
if (re.test(this.cellResult4)) {
let str = this.cellResult.substring(this.cellResult.lastIndexOf('细胞：') + 3, this.cellResult.lastIndexOf('个。'))
if (Number(this.cellResult4) > Number(str)) {
this.tip = '异常细胞数只能变小！'
this.tipShow = true
return false
} else {
let param = new URLSearchParams()
param.append('CASE_ID', this.caseId)
param.append('INITIAL_LESION_NUM', Number(str))
param.append('MODIFY_LESION_NUM', Number(this.cellResult4))
await this.$http.post(this.$vue.getData('DELETE_CROP_URL'), param)
cellRes = this.cellResult.substring(0, this.cellResult.lastIndexOf('细胞：') + 3) + this.cellResult4 + this.cellResult.substring(this.cellResult.lastIndexOf('个。'), this.cellResult.length)
}
} else {
this.tip = '异常细胞数请输入非负整数！'
this.tipShow = true
return false
}
params.append('cellResult', cellRes)
params.append('subjectResultText', this.subjectResultText)
params.append('method', method)
params.append('fzDoc', this.fzDoc.length === 1 ? '' : this.fzDoc.key)

eventBus.$emit('showLoading', true, '加载中')
let suc = await this.$http.post(this.$vue.getData('FINISH_DIAGNOSE'), params)
if (suc.data.result === '1') {

this.$router.push({ name: 'reportdetail', params: {data: suc.data.data, finishDiagnose: true} })
}

eventBus.$emit('showLoading', false)
},
back () {
this.$router.go(-1)
console.log(this.oneValue)
console.log(this.fourValue)
console.log(this.twoValue)
console.log(this.threeValue)
}
},
beforeRouteEnter (to, from, next) {

if (from.name === 'reportdetail') {
next({name: 'DzdCaseList'})
} else {
next()
}
}
}



// WEBPACK FOOTER //
// ./src/components/doctor/report/cellReportEdit.vue